module.exports = __webpack_public_path__ + "3ca9bd08e09b1ea408e2a0fdfc842e77.pdf";